import { Injectable } from '@angular/core';
import { NbMomentDateService } from '@nebular/moment';
import moment from 'moment';

// The datepickers run on moment (#1175), but many controls still hold native Dates, which
// NbMomentDateService calls moment methods on: the field stayed empty and the calendar
// opened in the corner. Every other method goes through clone() or one of these.
@Injectable()
export class AppDateService extends NbMomentDateService {
  clone(date) { return moment(date).locale(this.locale); }
  format(date, format: string) { return date ? moment(date).format(format || this.localeData.defaultFormat) : ''; }
  getMonth(date) { return moment(date).month(); }
  getHours(date) { return moment(date).hour(); }
  getMinutes(date) { return moment(date).minute(); }
  getSeconds(date) { return moment(date).second(); }
  getMilliseconds(date) { return moment(date).milliseconds(); }
  getWeekNumber(date) { return moment(date).week(); }
}
